import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * Global API response interceptor that converts API-level errors to HTTP errors.
 *
 * Many endpoints return HTTP 200 with `{ success: false, message: "...", statusCode: 400 }`
 * instead of proper HTTP error codes. This interceptor normalizes those responses
 * into HttpErrorResponse objects so they're handled consistently by error handlers.
 */
@Injectable()
export class ApiResponseInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      map((event) => {
        // Only check successful HTTP responses with a body
        if (event instanceof HttpResponse && event.body) {
          const body = event.body as any;

          // Check if this is a BaseResponse with success: false
          if (
            body &&
            typeof body === 'object' &&
            'success' in body &&
            body.success === false
          ) {
            // Convert API error to HttpErrorResponse
            // Throwing in map() properly propagates the error through the stream
            throw new HttpErrorResponse({
              error: body,
              headers: event.headers,
              status: body.statusCode ?? 400,
              statusText: body.message || 'Request failed',
              url: event.url || undefined
            });
          }
        }
        return event;
      })
    );
  }
}
